import React, {FC} from 'react';

import {ClickEventHandler} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {useUserTheme} from '../../../libs/shared/ui/src/theme/userThemeProvider';
import {
  ExpandableResourceCell,
  ExpandableResourceCellInheritableProps,
} from '../../components/common/table/cells/expandableResourceCell';
import {TableCellProps} from '../../components/common/table/cells/tableCell';
import {AnswerModel} from '../../models/api/answerModel';

/*
 * Props.
 */

interface SettingsAnswerNameCellProps
  extends Omit<ExpandableResourceCellInheritableProps<AnswerModel>, 'isExpanded'>,
    TableCellProps<AnswerModel> {
  onClick: ClickEventHandler;
  isInSearch: boolean;
  nestingLevel: number;
}

/*
 * Component.
 */

export const SettingsAnswersTableNameCell: FC<SettingsAnswerNameCellProps> = (props) => {
  const theme = useUserTheme();
  const {
    isSelected,
    isHovering,
    isLoading,
    size,
    settings,
    index,
    shouldShowStickyGradient,
    shouldRemoveTopBorderRadius,
    shouldRemoveBottomBorderRadius,
    value,
    isInSearch,
  } = props;

  const nestingLevel = isInSearch ? 0 : Math.min(props.nestingLevel || 0, 3);

  return (
    <ExpandableResourceCell<AnswerModel>
      isSelected={isSelected}
      isHovering={isHovering}
      isLoading={isLoading}
      size={size}
      settings={settings}
      index={index}
      shouldShowStickyGradient={shouldShowStickyGradient}
      shouldRemoveTopBorderRadius={shouldRemoveTopBorderRadius}
      shouldRemoveBottomBorderRadius={shouldRemoveBottomBorderRadius}
      nestingLevel={nestingLevel}
      hasChildren={false}
      shouldShowSubtitle
      shouldHideActions={false}
      value={value}
      onClick={props.onClick}
      onChevronClick={props.onChevronClick}
      onActionsDropdownOpened={props.onActionsDropdownOpened}
      renderActionsDropdown={({modalProps, value: dropdownValue}) =>
        props.renderActionsDropdown({modalProps, value: dropdownValue})
      }
      hasChevron={props.hasChevron}
      hasHover={props.hasHover}
      isExpanded={false}
      renderSubtitle={() => value?.blurb}
      iconProps={{
        name: 'messageTemplateSmall',
        backgroundColor: theme.greys.shade30,
      }}
    />
  );
};
